type Config = { [key: string]: string }

const config: Config = (window as any).acreEnv || {}
//Remember when adding configs to make sure you have considered any required changes to generateAppConfig.sh & .gitlab-ci.yml
export default {
  CLIENT_PORTAL_API_URL: config.CLIENT_PORTAL_API_URL || 'https://clientapi.acreplatforms.co.uk/v1',
  CLIENT_PORTAL_COOKIE_DOMAIN: config.CLIENT_PORTAL_COOKIE_DOMAIN || 'clientapi.acreplatforms.co.uk',
  ADDRESS_LOOKUP_API_TOKEN: config.ADDRESS_LOOKUP_API_TOKEN || 'PCWVM-5MZ4Z-GBQVY-ZY5PS',
  ADDRESS_LOOKUP_API_URL: config.ADDRESS_LOOKUP_API_URL
    ? config.ADDRESS_LOOKUP_API_URL
    : config.API1_URL
      ? `${config.API1_URL}/acre/propertydata`
      : 'https://api.acreplatforms.co.uk/v1/acre/propertydata',
  API_KEY: config.API_KEY || '95thesesc866aae7d64b9b63da48d804156ab71b',
  CLIENT_PORTAL_API_KEY: config.CLIENT_PORTAL_API_KEY || '41478a89646604b7455e036aca8f31671863b219',
  API_URL: config.API_URL || 'https://api.acreplatforms.co.uk/v1/acre',
  API1_URL: config.API1_URL || 'https://api.acreplatforms.co.uk/v1',
  COOKIE_DOMAIN: config.COOKIE_DOMAIN || '.acreplatforms.co.uk',
  FULLSTORY_ORG_ID: config.FULLSTORY_ORG_ID || 'QZVRC',
  GLOBAL_FEATURE_FLAGS: config.GLOBAL_FEATURE_FLAGS || '',
  // note the 'v2' in the GI URL - this is a new API
  GENERAL_INSURANCE_API_URL:
    config.GENERAL_INSURANCE_API_URL || 'https://api.acreplatforms.co.uk/v2/acre/general-insurance',
  GENERAL_INSURANCE_RSA_PUBLIC_KEY_URL:
    config.GENERAL_INSURANCE_RSA_PUBLIC_KEY_URL ||
    'https://files.staging.myac.re/discovery/rsa-public-key/general-insurance/staging_kms.pub',
  JWT_DOMAIN: config.JWT_DOMAIN || 'https://localhost.luthersystemsapp.com:9001/json',
  LOGOUT_URL: config.LOGOUT_URL || 'https://api.acreplatforms.co.uk/v1/user/logout',
  CLIENT_PORTAL_LOGOUT_URL: config.CLIENT_PORTAL_LOGOUT_URL || 'https://clientapi.acreplatforms.co.uk/v1/client/logout',
  INTRODUCER_PORTAL_URL: config.INTRODUCER_PORTAL_URL || 'https://introducers.staging.acreplatforms.co.uk',
  PROTECTION_API_URL: config.PROTECTION_API_URL || 'https://api.acreplatforms.co.uk/v1/acre/protection',
  PROTECTION_RSA_PUBLIC_KEY_URL:
    config.PROTECTION_RSA_PUBLIC_KEY_URL ||
    'https://files.staging.myac.re/discovery/rsa-public-key/protection/staging_kms.pub',
  REFRESH_URL: config.REFRESH_URL || 'https://api.acreplatforms.co.uk/v1/user/refresh',
  SEARCH_API_URL: config.API1_URL
    ? `${config.API1_URL.replace(/v1/, 'v2')}/acre/search/` // TODO this is only necessary til we fully release this
    : 'https://api.acreplatforms.co.uk/v2/acre/search/',
  SENTRY_ENVIRONMENT: config.SENTRY_ENVIRONMENT || 'localhost.myac.re',
  SWAGGER_URL: 'https://api.acreplatforms.co.uk/swagger.json',
  CH_API_URL: config.API1_URL
    ? `${config.API1_URL}/acre/companies-house`
    : 'https://api.acreplatforms.co.uk/v1/acre/companies-house',
  PROPERTY_INFO_API_URL: config.PROPERTY_INFO_API_URL || 'https://api.acreplatforms.co.uk/v1/acre/propertydata',
  MAP_SERVER_API_URL: config.MAP_SERVER_API_URL || 'https://api.acreplatforms.co.uk/geoserver',
  // This is used to determine the env - local points to staging
  CLIENT_ORIGINATOR: config.CLIENT_ORIGINATOR || '1a1270bc-69f1-4ace-89f8-336828251e6e',
  MATOMO_BASE_URL: config.MATOMO_BASE_URL || 'https://analytics.acreplatforms.co.uk/',
  MATOMO_SITE_ID: config.MATOMO_SITE_ID || '1',
  // this is integration id, change to staging when available
  ACRE_SUPPORT_ORG_ID: config.ACRE_SUPPORT_ORG_ID || '9dea9381-7771-4caa-aa8d-6e4d86219fd4',
  NOTIFICATIONS_URL: config.NOTIFICATIONS_URL || 'wss://api.acreplatforms.co.uk/v1/acre/notifications/ws/subscribe',
  MIXPANEL_TOKEN: config.MIXPANEL_TOKEN || 'dc6ff9779655a9300019b1df14710a7e',
  ZAPIER_URL:
    config.ZAPIER_URL || 'https://zapier.com/developer/public-invite/161225/b84afeca11e61c2a55e466c187ea79f0/',
  OAUTH_PROVIDER: config.OAUTH_PROVIDER || 'https://oauth.acreplatforms.co.uk/',
  AUTH_URL: config.AUTH_URL || 'https://acresoftware.b2clogin.com',
  AUTH_ID: config.AUTH_ID || 'e0dd1d84-d4ec-4ced-ac1e-0b87e83cdd10',
}
